import axios from 'axios';
import { CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

export interface MasterDetailList {
  pcmCd: string;
  pcmCdNm: string;
}

export interface DisplayItem {
  displayItemId: string;
  displayItemName: string;
  displayInputMethodType: string;
  setValuePcmCdDivision: string;
  displayLabelText: string;
  requiredItemFlg: boolean;
  displayItemFlg: boolean;
  requiredDisplayItemFlg: boolean;
  displayAreaType: string;
  displayRow: number;
  displayColumn: number;
  styleClassName: string;
}

export interface MasterDetailApiGetAllDisplayItemResponse {
  displayItemList: Array<DisplayItem>;
  result: CommonResult;
}

export interface PcmCodeInfo {
  pcmCd: string;
  pcmCdNm: string;
  pcmCdClassification: string;
  displayItemId: string;
  pcmCdDisplayOrder: number;
}

export interface PcmCodeDivision {
  pcmCdDivision: string;
  fieldNm: string;
  pcmCdDivisionNm: string;
  pcmCodeList: Array<PcmCodeInfo>;
}

export interface MasterDetailApiGetAllPcmCodeResponse {
  pcmCodeDivisionList: Array<PcmCodeDivision>;
  result: CommonResult;
}

export interface MyShopTodayDetailResponse {
  result: CommonResult;
}

export const masterDetailApiGetAllDisplayItem = async (): Promise<MasterDetailApiGetAllDisplayItemResponse> => {
  try {
    const URL = createApiRequestUrl('master/displayItem');
    const response = await axios.get<MasterDetailApiGetAllDisplayItemResponse>(URL);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      displayItemList: [],
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
};

export const masterDetailApiGetAllPcmCode = async (): Promise<MasterDetailApiGetAllPcmCodeResponse> => {
  try {
    const URL = createApiRequestUrl('master/pcmCode');
    const response = await axios.get<MasterDetailApiGetAllPcmCodeResponse>(URL);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      pcmCodeDivisionList: [],
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
};

export const postMyShopTodayDetail = async (): Promise<MyShopTodayDetailResponse> => {
  try {
    const URL = createApiRequestUrl('myShopDetail/update');
    const response = await axios.post<MyShopTodayDetailResponse>(URL);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
};
